import { Autocomplete } from '@material-ui/lab';
import { FormControlLabel, TextField } from '@material-ui/core';
import { Checkbox } from '@sharedComponents/Checkbox';
import { useEffect, useState } from 'react';

import 'index.scss';

export interface IMultipleLimitTagsAutocomplete {
  id: string;
  name: string;
  selected: boolean;
}

interface props {
  options: IMultipleLimitTagsAutocomplete[];
  onUpdateCurrentOptions?: (options: IMultipleLimitTagsAutocomplete[]) => void;
  onRemoveOption?: (option: IMultipleLimitTagsAutocomplete) => void;
  onSelectOption?: (option: IMultipleLimitTagsAutocomplete) => void;
  errorHelper?: string;
}

const MultipleLimitTagsAutocomplete = ({
  options,
  onUpdateCurrentOptions,
  onRemoveOption,
  onSelectOption,
  errorHelper = '',
}: props) => {
  const [selectedOptions, setSelectedOptions] = useState(
    options?.filter((option) => option?.selected)
  );
  const [currentOptions, setCurrentOptions] = useState([...options]);
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    setSelectedOptions(options.filter((option) => option.selected));
    setCurrentOptions([...options]);
  }, [options]);

  const handleToggle = (value, reason, details) => {
    if (reason === 'remove-option' && onRemoveOption) {
      if (!value.length) {
        setIsError(true);
        setSelectedOptions([{ ...details.option }]);
      } else {
        onRemoveOption(details.option);
        setSelectedOptions(value);
      }
    }
    if (reason === 'select-option' && onSelectOption) {
      onSelectOption(details.option);
      setIsError(false);
      setSelectedOptions(value);
    }
  };

  useEffect(() => {
    const data = options.map((item) => {
      const isSelected = selectedOptions.find((option) => option.id === item.id);
      return isSelected
        ? {
            ...item,
            selected: true,
          }
        : {
            ...item,
            selected: false,
          };
    });
    setCurrentOptions(data);
  }, [selectedOptions]);

  useEffect(() => {
    if (currentOptions && onUpdateCurrentOptions) {
      onUpdateCurrentOptions(currentOptions);
    }
  }, [currentOptions]);

  return (
    <div className="multi-autocomplete-container" data-testid="multi-autocomplete-test-container">
      <Autocomplete
        id="multi-autocomplete"
        multiple
        disableCloseOnSelect
        limitTags={2}
        value={selectedOptions}
        disableClearable
        getOptionSelected={(option, value) => option.id === value.id}
        renderInput={(params) => (
          <TextField
            {...params}
            label=""
            error={isError}
            helperText={isError ? errorHelper : ''}
            placeholder="Allowed Groups"
            data-testid="multi-autocomplete-input"
          />
        )}
        options={options}
        onChange={(event, value, reason, details) => handleToggle(value, reason, details)}
        getOptionLabel={(option) => option.name}
        renderOption={(option, { selected }) => (
          <FormControlLabel
            checked={selected}
            control={<Checkbox checked={selected} />}
            label={option.name}
            data-testid={`autocomplete-option-label-${option.id}`}
          />
        )}
      />
    </div>
  );
};

export default MultipleLimitTagsAutocomplete;
